export enum Brand {
	Straumann = "Straumann",
	Neodent = "Neodent",
	ClearCorrect = "ClearCorrect"
}